var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.728 5.36806L12.1673 4.71248L10.1056 0.560474C9.76193 -0.157542 8.69984 -0.18876 8.32498 0.560474L6.29451 4.71248L1.70253 5.36806C0.890339 5.49294 0.577959 6.49192 1.17148 7.08506L4.45147 10.3005L3.67052 14.8272C3.54557 15.6388 4.42023 16.2632 5.13871 15.8886L9.23089 13.7345L13.2918 15.8886C14.0103 16.2632 14.885 15.6388 14.76 14.8272L13.9791 10.3005L17.2591 7.08506C17.8526 6.49192 17.5402 5.49294 16.728 5.36806ZM12.3547 9.76982L13.1044 14.0779L9.23089 12.0487L5.32614 14.0779L6.07585 9.76982L2.92081 6.71044L7.26289 6.08608L9.23089 2.1526L11.1676 6.08608L15.5097 6.71044L12.3547 9.76982Z",
    fill: "#E6A151"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ce1b3730a3169a1c987f178feb425fdc.svg";
export { ForwardRef as ReactComponent };